import {
  getSaaSproviders,
  getAppDetailInfo,
  createOrder
} from '@/api/payment';

import { fetchMyOrderInfoState } from '@/api/myOrder';
import { createWechatPay, queryWechatPayStatus } from '@/api/wechatPay';

const order = {
  state: {},
  actions: {
    GetSaaSProviders({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        getSaaSproviders(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAppInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAppDetailInfo(data.eid, data.appKeyID, data.appVersion)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 订单生出
    CreateOrder(_, resdata) {
      return new Promise((resolve, reject) => {
        createOrder(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetOrderStatusEvent({ commit }, data) {
      return new Promise((resolve, reject) => {
        fetchMyOrderInfoState(data.eid, data.orderID)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建微信支付
    CreateWechatPay(_, orderID) {
      return new Promise((resolve, reject) => {
        createWechatPay(orderID)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 查询微信支付状态
    QueryWechatPayStatus(_, orderID) {
      return new Promise((resolve, reject) => {
        queryWechatPayStatus(orderID)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  mutations: {}
};

export default order;



// WEBPACK FOOTER //
// ./src/store/modules/order.js